interface FilterBarProps {
  sortBy: "name" | "models";
  onSortChange: (sort: "name" | "models") => void;
  totalBrands: number;
  totalModels: number;
  totalDiscontinuedModels?: number;
}

export const FilterBar = ({
  sortBy,
  onSortChange,
  totalBrands,
  totalModels,
  totalDiscontinuedModels,
}: FilterBarProps) => {
  const handleSortChange = (value: "name" | "models") => {
    onSortChange(value);
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-8 pb-6 border-b border-border">
      <div className="flex items-center gap-4 sm:gap-6 text-sm flex-wrap justify-center sm:justify-start">
        <div className="flex items-center gap-2">
          <span className="text-muted-foreground font-light">Marques:</span>
          <span className="font-semibold text-foreground">{totalBrands}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-muted-foreground font-light">Models:</span>
          <span className="font-semibold text-foreground">{totalModels}</span>
        </div>
        {totalDiscontinuedModels && totalDiscontinuedModels > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-muted-foreground font-light">Descatalogats:</span>
            <span className="font-semibold text-red-500">{totalDiscontinuedModels}</span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground font-light">Ordenar:</span>
        <div className="flex gap-2">
          <button
            onClick={() => handleSortChange("name")}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              sortBy === "name"
                ? "bg-foreground text-background"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
            }`}
            type="button"
          >
            A-Z
          </button>
          <button
            onClick={() => handleSortChange("models")}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              sortBy === "models"
                ? "bg-foreground text-background"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
            }`}
            type="button"
          >
            Més models
          </button>
        </div>
      </div>
    </div>
  );
};

